/* ============================================
   PEPTIDE POTION — Main JavaScript
   ============================================ */

// FAQ Accordion
document.querySelectorAll('.faq-question').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.parentElement;
    var wasOpen = item.classList.contains('open');
    // Close all
    document.querySelectorAll('.faq-item').forEach(function(i) {
      i.classList.remove('open');
    });
    // Toggle current
    if (!wasOpen) {
      item.classList.add('open');
    }
  });
});

// Mobile Nav Toggle
function toggleMobileNav() {
  var links = document.querySelector('.nav-links');
  if (!links) return;

  if (links.style.display === 'flex') {
    links.style.display = 'none';
  } else {
    links.style.display = 'flex';
    links.style.flexDirection = 'column';
    links.style.position = 'absolute';
    links.style.top = '60px';
    links.style.left = '0';
    links.style.right = '0';
    links.style.background = 'rgba(10,15,26,.95)';
    links.style.padding = '24px';
    links.style.gap = '20px';
    links.style.alignItems = 'center';
  }
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    var href = this.getAttribute('href');
    // Skip bare '#' or '#!' — not a real scroll target, and querySelector('#') throws
    if (!href || href === '#' || href === '#!') {
      e.preventDefault();
      return;
    }
    var target;
    try { target = document.querySelector(href); } catch (err) { return; }
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Close mobile nav if open
      var links = document.querySelector('.nav-links');
      if (links && window.innerWidth <= 900) {
        links.style.display = 'none';
      }
    }
  });
});
